import Head from 'next/head';
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Container,
  Link,
  List,
  ListItem,
} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useRef, useState} from 'react';
import Slider from 'react-slick';
import CloseIcon from '@mui/icons-material/Close';
import {useRouter} from 'next/router';
import {BaseFooter} from '@jobseeker/lotus/components';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import Button from '@jobseeker/lotus/elements/Button';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiFillTwitterSquare,
  AiOutlineHome,
} from 'react-icons/ai';
import {wrapper} from '@jobseeker/common-core/stores';

const PLATFORM = process.env.NEXT_PUBLIC_APP_NAME;
const isAppIIMJobs = PLATFORM === 'iimjobs';

export default function Veranda() {
  const images: Record<string, {src: string[]}> = {
    'Trust of Veranda HigherEd to Upskill and Empower': {
      src: [
        'https://static.iimjobs.com/partner_assets/images/verandahover1.jpg',
      ],
    },
    'World Class Learning Experience': {
      src: [
        'https://static.iimjobs.com/partner_assets/images/verandahover2.jpg',
      ],
    },
    'Learn from the Best Faculty and Industry Experts': {
      src: [
        'https://static.iimjobs.com/partner_assets/images/verandahover3.jpg',
      ],
    },
  };

  const isLarge = useIsLargeDevice(600);

  const router = useRouter();
  const [selectedTitle, setSelectedTitle] = useState<string>(
    Object.keys(images)[0]
  );

  const [expanded, setExpanded] = useState(false);

  const handleReadMore = () => {
    setExpanded(prev => !prev);
  };

  const [activeSection, setActiveSection] = useState<string>('ABOUT US');

  const courses = [
    {
      title: 'GIM | Post Graduated Diploma In Management',
      description: [
        '2 Years',
        'In Person Sessions on Campus',
        'Learn from Industry Expert',
        'Entrepreneurial Support',
        'Individualized Career Support',
      ],
      imageSrc:
        'https://static.iimjobs.com/partner_assets/images/veranda-gim-pgdm.jpg',
      link: 'https://www.iimjobs.com/course/gim-post-graduated-diploma-in-management-2456.html?ref=lc&reforg=learning&refinv=learning',
    },
    {
      title: 'SASTRA | Master of Business Administration',
      description: [
        '2 Years',
        'Recognized MBA from a Top Ranked University.',
        'Masterclasses by Industry Experts Immersive.',
        'Hand-on Practice and Experiential Exercises.',
        'Career Support Services',
      ],
      imageSrc:
        'https://static.iimjobs.com/partner_assets/images/veranda-sastra-mba.jpg',
      link: 'https://www.iimjobs.com/course/sastra-master-of-business-administration-2448.html?reforg=showcase&refinv=lg_showcase',
    },
    {
      title: 'IIM Raipur | Executive Development Program in General Management',
      description: [
        '1 Year',
        'Certificate of Completion',
        'Experience the Campus',
        'Gain Hands-on Experience',
        'In-depth Exposure of Emerging Themes',
        'Acquire 360-Degree Approach of Management',
        'Personalized Career Support Services',
        'Access to an Exclusive Startup Bootcamp',
        'Gain Executive Alumni Status',
      ],
      imageSrc:
        'https://static.iimjobs.com/partner_assets/images/veranda-iim_raipur-gm.jpg',
      link: 'https://www.iimjobs.com/course/iim-raipur-executive-development-program-in-general-management-2417.html?reforg=showcase&refinv=lg_showcase',
    },
    {
      title: 'XLRI | Executive Development Program In Driving Growth',
      description: [
        '11 Months',
        'Build effective, Value-Oriented organizations',
        'Develop skills in Tools & Frame works to formulate and implement effective strategies for competing and growth',
        'Appreciate the intricacies of Leadership and Driving Teams',
        'Understand the challenges and opportunities thrown up by Digital Business Models',
        'Cultivate a Holistic approach to Management functions & roles',
        'Deal with key pain-points in managing an organization',
      ],
      imageSrc:
        'https://static.iimjobs.com/partner_assets/images/veranda-xlri-cxo.jpg',
      link: 'https://www.iimjobs.com/course/xlri-executive-development-program-in-driving-growth-2521.html?reforg=showcase&refinv=lg_showcase',
    },
  ];

  const handleMenuClick = (event: React.MouseEvent, section: string) => {
    router.push(`#${section}`);
    setActiveSection(section);
    // Track event (optional GA tracking)
  };
  const [isCarouselOpen, setCarouselOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleCarouselOpen = () => {
    setCarouselOpen(true);
  };

  const handleCarouselClose = () => {
    setCarouselOpen(false);
  };

  const handleBeforeChange = (oldIndex: number, newIndex: number) => {
    setCurrentSlide(newIndex);
  };

  const mainSliderRef = useRef<Slider | null>(null);

  const carousel_Images = ['img_4', 'img_2', 'img_3', 'img_1'];

  const handleThumbnailClick = (index: number) => {
    setCurrentSlide(index);
    mainSliderRef?.current?.slickGoTo(index);
  };

  if (!isAppIIMJobs) {
    return <></>;
  }

  return (
    <>
      <Head>
        <title>
          Showcasing Veranda Learning is one of India’s leading Ed-Tech firms.
        </title>
        <meta
          name="description"
          content="A champion in executive learning, Veranda HigherEd is one of India’s leading Ed-Tech firms. Dedicated to creating leadership in the ever-changing business world, we are the first to bring ‘Live & Interactive’ anywhere learning in digital format."
        />
        <meta
          name="keywords"
          content="Veranda HigherEd offers exclusive courses for modern industry leaders. Our ability to recreate classroom-type interactions in the virtual world has struck a chord with over 5,00,000 individuals and corporate learners, facilitating a social collaborative learning experience in digital space."
        />
        <link
          rel="shortcut icon"
          href="https://www.iimjobs.com/resources/images/favicon.ico"
        />
      </Head>
      <Box
        sx={{
          mx: 'auto',
          width: {xxs: '100%', md: '80%', lg: '80%', xl: '80%'},
          mt: isLarge ? 5 : 0,
        }}
      >
        <Grid
          container
          width="100%"
          alignItems="center"
          justifyContent="center"
          gap={isLarge ? 1 : 0}
        >
          <Grid
            item
            xs={12}
            md={4}
            lg={4}
            xl={3.4}
            sx={{
              ...(isLarge && {border: '1px solid #f3ede5'}),
              backgroundColor: '#fdf9f4',
              p: {xxs: 2, lg: 8},
              display: 'flex',
              flexDirection: 'column',
              alignItems: {xxs: 'center', md: 'flex-start'},
            }}
          >
            <Typography
              mt={{md: 0, xxl: 4}}
              fontSize={15}
              fontWeight={700}
              gutterBottom
              textAlign="center"
              fontFamily={'Roboto'}
            >
              SHOWCASING
            </Typography>
            <Box sx={{textAlign: {xxs: 'center', md: 'left'}}} mt={1}>
              <Image
                src={
                  'https://static.iimjobs.com/partner_assets/images/veranda-logo.jpg'
                }
                alt="VC Now, Top International Business School in India"
                width={isLarge ? 220 : 160}
                height={isLarge ? 100 : 70}
                style={{objectFit: 'cover'}}
              />
            </Box>
            {!isLarge && (
              <Box
                mt={2}
                sx={{
                  backgroundColor: 'red',
                  height: '4px',
                  width: '35%',
                }}
              />
            )}

            {isLarge && (
              <>
                <Box
                  sx={{backgroundColor: '#cf381e', height: '4px', width: '35%'}}
                />
                <Typography
                  fontSize={24}
                  fontWeight={700}
                  gutterBottom
                  mb={1.875}
                  textAlign="left"
                  fontFamily={'Roboto'}
                  mt={6}
                >
                  Your Learning Partner
                </Typography>
                <Typography
                  fontSize={{xxs: 13, md: 16}}
                  variant="body1"
                  mb={{md: 0, xxl: 15}}
                  fontFamily={'Roboto'}
                >
                  Explore what you will get in your learning journey, browse
                  through course and read what others say about us.
                </Typography>
              </>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            md={7}
            lg={7.5}
            xl={6.7}
            textAlign="center"
            sx={{...(!isLarge && {backgroundColor: '#fdf9f4'})}}
          >
            <Box
              sx={{
                cursor: 'pointer',
                position: 'relative',
                display: 'inline-block',
              }}
              onClick={handleCarouselOpen}
            >
              <Image
                src="https://static.iimjobs.com/partner_assets/images/veranda-banner-two.jpg"
                alt="Image"
                layout="intrinsic"
                width={isLarge ? 850 : 300}
                height={isLarge ? 700 : 500}
                style={{objectFit: 'cover'}}
              />

              <Button
                variant="contained"
                sx={{
                  color: 'white',
                  backgroundColor: '#333',
                  position: 'absolute',
                  bottom: 36,
                  left: '50%',
                  transform: 'translateX(-50%)',
                }}
              >
                View Photos
              </Button>
            </Box>
          </Grid>
        </Grid>
        {!isLarge && (
          <Box
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
            flexDirection={'column'}
            sx={{
              ...(!isLarge && {backgroundColor: '#fdf9f4'}),
              backgroundColor: '#fdf9f4',
              py: 4,
              px: 2,
            }}
          >
            <Typography
              fontFamily={'Roboto'}
              fontSize={18}
              fontWeight={700}
              gutterBottom
              lineHeight={1.4}
              mb={1.875}
              textAlign="left"
              mt={3}
            >
              Your Learning Partner
            </Typography>
            <Typography variant="body1" fontFamily={'Roboto'}>
              Explore what you will get in your learning journey, browse through
              course and read what others say about us.
            </Typography>
          </Box>
        )}
        {isCarouselOpen && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}
          >
            <Box
              sx={{
                position: 'relative',
                width: isLarge ? '50%' : '70%',
                height: {xxs: '20%', md: '50%', lg: '85.3%'},
                borderRadius: '8px',
              }}
            >
              <IconButton
                onClick={handleCarouselClose}
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: isLarge ? 34 : 16,
                  color: 'black',
                  backgroundColor: 'white',
                  width: isLarge ? 40 : 30,
                  height: isLarge ? 40 : 30,
                  zIndex: 10,
                  '&:hover': {
                    backgroundColor: 'white',
                    color: 'black',
                    boxShadow: 'none',
                  },
                }}
              >
                <CloseIcon />
              </IconButton>

              {/* Main Carousel */}
              <Slider
                ref={mainSliderRef}
                infinite
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                arrows
                beforeChange={handleBeforeChange}
              >
                {carousel_Images.map((image, index) => (
                  <Box key={index}>
                    <Image
                      src={`https://static.iimjobs.com/partner_assets/images/veranda_showcase_${image}.jpg`}
                      alt={`Carousel Image ${index + 1}`}
                      width={1000}
                      height={400}
                      layout="intrinsic"
                      style={{
                        margin: '0 auto',
                      }}
                    />
                  </Box>
                ))}
              </Slider>

              {/* Thumbnail Carousel */}
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 2,
                  gap: 1,
                }}
              >
                {carousel_Images.map((image, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: '120px',
                      height: isLarge ? '80px' : '30px',
                      padding: '0px',
                      cursor: 'pointer',
                      border:
                        currentSlide === index
                          ? '2px solid #1976d2'
                          : '2px solid transparent',
                      transition: 'border 0.3s',
                    }}
                    onClick={() => handleThumbnailClick(index)}
                  >
                    <Image
                      src={`https://static.iimjobs.com/partner_assets/images/veranda_showcase_${image}.jpg`}
                      alt={`Thumbnail ${index + 1}`}
                      width={150}
                      height={100}
                      layout="intrinsic"
                    />
                  </Box>
                ))}
              </Box>
            </Box>

            {/* Current Slide Indicator */}
            <Box
              sx={{
                backgroundColor: 'white',
                padding: 1.5,
                position: 'absolute',
                bottom: 16,
                left: '50%',
                transform: 'translateX(-50%)',
                color: '#333',
                fontWeight: '700',
              }}
            >
              <Typography variant="body2" fontFamily={'Roboto'}>
                Photo {currentSlide + 1} of {carousel_Images.length}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
      <Box component="main" mt={5}>
        {/* Menu Section */}
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            background: 'white',
            zIndex: 10,
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
            paddingY: 3,
            overflowX: 'auto',
            width: '100%',
            whiteSpace: 'nowrap',
          }}
        >
          <Container sx={{paddingX: 0}}>
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
              sx={{
                flexWrap: 'nowrap',
                width: 'max-content',
                margin: '0 auto',
              }}
            >
              {['ABOUT US', 'WHY US', 'COURSES'].map(section => (
                <Grid item key={section}>
                  <Link
                    href={`#${section}`}
                    variant="button"
                    sx={{
                      color: 'text.primary',
                      fontSize: isLarge ? 22 : 18,
                      textDecoration: 'none',
                      fontWeight: 600,
                      paddingX: 0.75,
                      fontFamily: 'Roboto',
                      paddingY: 0.5,
                      borderRadius: 1,
                      transition: 'all 0.3s ease-in-out',
                      '&.active': {
                        color: '#d13319',
                      },
                    }}
                    className={activeSection === section ? 'active' : ''}
                    onClick={event => handleMenuClick(event, section)}
                  >
                    {section.toUpperCase()}
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>

        {/* About Section */}
        <Container id="ABOUT US" sx={{py: 6}}>
          <Box display={'flex'} flexDirection={{md: 'row', xxs: 'column'}}>
            <Typography
              fontFamily={'Roboto'}
              lineHeight={1.4}
              fontSize={{xxs: 25, md: 30}}
              fontWeight={600}
              sx={{
                textAlign: {xxs: 'center', md: 'left'},
              }}
              gutterBottom
              {...(isLarge && {borderRight: '2px solid #f1f1f1', pr: 6})}
            >
              About <br />
              Veranda {isLarge && <br />}
              HigherEd
            </Typography>
            <Box
              display={'flex'}
              justifyContent={'center'}
              flexDirection={'column'}
              pl={2}
            >
              <Typography
                fontFamily={'Roboto'}
                paragraph
                sx={{lineHeight: 1.9}}
                fontSize={isLarge ? 20 : 18}
                fontWeight={400}
              >
                A higher education vertical of Veranda Learning, we are
                committed to offering the best online learning experience to the
                Indian workforce. Veranda HigherEd has partnered with some of
                the leading institutes and corporations in India and abroad for
                you to upskill and upgrade in no time.
                {expanded && (
                  <>
                    Embark on a career success journey with us as we offer
                    hassle-free learning with unparalleled added advantages that
                    come along with our courses.
                  </>
                )}
              </Typography>
              <Button
                variant="text"
                disableRipple
                sx={{
                  mt: -1,
                  color: '#8f6534',
                  fontSize: '15px',
                  height: 'fit-content',
                  display: 'flex',
                  justifyContent: {xxs: 'center', md: 'flex-start'},
                  '&:hover': {
                    backgroundColor: 'inherit',
                    textDecoration: 'underline',
                    boxShadow: 'none',
                  },
                }}
                size="small"
                onClick={handleReadMore}
              >
                {expanded ? 'Read Less' : 'Read More'}
              </Button>
            </Box>
          </Box>
        </Container>
        <Box id="WHY US" my={5}>
          <Container>
            <Typography
              fontSize={{xxs: 25, md: 30}}
              fontFamily={'Roboto'}
              fontWeight={600}
              align="center"
              mb={3}
              gutterBottom
            >
              Why Us?
            </Typography>
            <Grid
              container
              alignItems="flex-start"
              justifyContent="center"
              mt={5}
              gap={1}
              direction={{xs: 'column-reverse', md: 'row'}}
            >
              <Grid item xs={12} md={7.6}>
                <Grid
                  container
                  py={8}
                  px={4}
                  direction="column"
                  gap={6}
                  sx={{
                    backgroundColor: '#fdf9f4',
                    border: '1px solid #f3ede5',
                    paddingBottom: 6,
                  }}
                >
                  <List disablePadding>
                    {Object.keys(images).map((title, idx) => (
                      <ListItem
                        key={idx}
                        disableGutters
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                          pl: 0,
                          cursor: 'pointer',
                        }}
                        onMouseEnter={() => setSelectedTitle(title)}
                      >
                        <Box
                          sx={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: 'red',
                            borderRadius: '50%',
                            position: 'absolute',
                            left: 0,
                            marginTop: '10px',
                          }}
                        />
                        <Box sx={{position: 'relative', pl: 2}}>
                          <Typography
                            fontFamily={'Roboto'}
                            fontSize={17}
                            sx={{
                              color:
                                selectedTitle === title
                                  ? 'secondary.main'
                                  : '#808080',
                              fontWeight: 400,
                              '&:hover': {
                                textDecoration: 'none',
                              },
                            }}
                          >
                            {title}
                          </Typography>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Grid>

              <Grid item xs={12} md={4}>
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={2}
                  alignItems="center"
                  justifyContent="flex-start"
                  height="100%"
                >
                  {images[selectedTitle]?.src.map((img, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        width: '100%',
                        height: 'auto',
                        borderRadius: '8px',
                        overflow: 'hidden',
                      }}
                    >
                      <Image
                        src={img}
                        alt={`Image ${idx + 1}`}
                        width={320}
                        height={238}
                      />
                    </Box>
                  ))}
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Container id="COURSES" sx={{mb: 5}}>
          <Box sx={{border: '1px solid #e0e0e0'}}>
            <Box textAlign="center" mb={3.75} mt={6.25}>
              <Typography
                fontSize={{xxs: '1rem', md: 30}}
                fontWeight={700}
                color="#2b2b2b"
                lineHeight={1.4}
                fontFamily={'Roboto'}
              >
                Give wings to your career by{!isLarge && <br />}
                {` `}
                <Typography
                  fontFamily={'Roboto'}
                  component="span"
                  fontSize={{xxs: '1rem', md: 30}}
                  fontWeight={700}
                  sx={{color: 'red'}}
                >
                  learning skills of your interest
                </Typography>
              </Typography>
              <Typography
                fontSize={19}
                fontWeight={500}
                color="secondary.dark"
                mt={2}
                fontFamily={'Roboto'}
              >
                Explore courses based on your interest.
              </Typography>
            </Box>

            <Grid container spacing={0} direction="column">
              {courses.map((course, index) => (
                <Grid item key={index}>
                  <Box
                    display="flex"
                    alignItems="center"
                    overflow="hidden"
                    gap={3}
                    p={isLarge ? 3 : 2}
                    flexDirection={{xs: 'column', sm: 'row'}}
                    sx={{
                      borderTop: '1px solid #e0e0e0',
                    }}
                  >
                    <Box flex={{xs: '1', md: '4'}}>
                      <Link href={course.link} target="_blank" underline="none">
                        <Typography
                          fontSize={isLarge ? 18 : 16}
                          fontWeight={500}
                          color="secondary.dark"
                          fontFamily={'Roboto'}
                        >
                          {course.title}
                        </Typography>
                      </Link>
                      <List
                        dense
                        disablePadding={!isLarge}
                        sx={{
                          my: isLarge ? 0 : 1,
                          listStyleType: 'none',
                          pl: 0,
                          '& .MuiListItem-root': {
                            display: 'list-item',
                            paddingLeft: 0,
                          },
                        }}
                      >
                        {course.description.map((desc, idx) => (
                          <ListItem key={idx}>
                            <Typography
                              lineHeight={1.1}
                              fontSize={15}
                              fontWeight={400}
                              color="secondary.dark"
                              fontFamily={'Roboto'}
                            >
                              {desc}
                            </Typography>
                          </ListItem>
                        ))}
                      </List>
                      <Button
                        variant="outlined"
                        sx={{
                          fontSize: '13px',
                          borderColor: '#c3c3c3',
                          px: 2,
                          py: 0.75,
                          height: 'fit-content',
                          '&:hover': {
                            borderColor: '#c3c3c3',
                            backgroundColor: 'transparent',
                          },
                        }}
                        size="small"
                      >
                        <Link
                          href={course.link}
                          target="_blank"
                          underline="none"
                          color={'#8f6534'}
                        >
                          View Course
                        </Link>
                      </Button>
                    </Box>

                    {isLarge && (
                      <Box flex="1">
                        <Link href={course.link} target="_blank">
                          <Image
                            src={course.imageSrc}
                            alt={course.title}
                            width={200}
                            height={150}
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: 'auto',
                            }}
                          />
                        </Link>
                      </Box>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
      <BaseFooter
        logoUrl="/logo/iimjobs_footer.svg"
        socialLinks={[
          {
            icon: <AiFillFacebook />,
            url: 'https://www.facebook.com/VerandaHigherEd',
          },
          {
            icon: <AiFillTwitterSquare />,
            url: 'https://twitter.com/verandahighered',
          },
          {
            icon: <AiFillLinkedin />,
            url: 'https://www.linkedin.com/company/veranda-highered/',
          },
          {
            icon: <AiOutlineHome />,
            url: 'https://verandahighered.com/',
          },
        ]}
        headerLabel={`iimjobs.com © ${new Date()
          .getFullYear()
          .toString()}. All rights reserved.`}
        page={''}
        jobLoading={false}
        termsLink={'/terms'}
      />
    </>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(() => async () => {
  if (!isAppIIMJobs) {
    return {
      notFound: true,
    };
  }

  return {
    props: {},
  };
});
